module.exports = __webpack_public_path__ + "img/twos.f00b9a47.png";